/* v8 ignore start */
import {Utils} from "../utils";

export class JsonModel<TJson> {
  protected json: TJson;

  public constructor(json: TJson) {
    this.json = json;
  }

  public update(partial: Partial<TJson>): this {
    return new (this.constructor as any)({...this.json, ...partial});
  }

  public toObject(): TJson {
    return this.json;
  }

  public deepClonedObject(): TJson {
    try {
      return structuredClone(this.json);
    } catch {
      // Fallback for older browsers
      return JSON.parse(JSON.stringify(this.json));
    }
  }

  public isEqual(other: JsonModel<TJson>): boolean {
    return Utils.isDeepEqual(this.json, other.json);
  }
}

export namespace JsonModel {
  export interface IType<TJson> {
    new (json: TJson): any;
  }

  export type TJson<T extends IType<any>> = T extends IType<infer R> ? R : any;
}
/* v8 ignore stop */
